import React from 'react';

import { Tooltip } from '@mui/material';

import RemoveIcon from '@mui/icons-material/Remove';
import DeviceUnknownIcon from '@mui/icons-material/DeviceUnknown';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import LaptopIcon from '@mui/icons-material/Laptop';
import StoreIcon from '@mui/icons-material/Store';


// Idéalement il nous faudrait une librairie ie : https://www.hexa-web.fr/blog/creating-an-icon-library-with-react-nextjs-and-typescript
// Explorer ça pour la transfo svg => composant : https://gregberge.com/fr/blog/svg-to-react-component-with-svgr
import { RapidoIcon } from 'components/Shared/Icons/RapidoIcon';
import { ATCIcon } from 'components/Shared/Icons/ATCIcon';

import { LitigeGestionCanal, LitigeGestionCanalEnum } from 'types/enums'


type Props = {
    canal:  null | LitigeGestionCanal
}



export default function LitigeCanalIcon({canal} : Props) {


    if(canal === null){
        return <RemoveIcon sx={{ fontSize: 36 }} />;
    }

    switch (canal) {

        case LitigeGestionCanalEnum.ATC :
            return <Tooltip title={"ATC"}><span><ATCIcon height={36} width={36}/></span></Tooltip>;
        case LitigeGestionCanalEnum.ATCS :
            return <Tooltip title={"ATCS"}><HeadsetMicIcon sx={{ fontSize: 36 }} /></Tooltip>;
        case LitigeGestionCanalEnum.Magasin :
            return <Tooltip title={"Magasin"}><StoreIcon sx={{ fontSize: 36 }} /></Tooltip>;
        case LitigeGestionCanalEnum.Web :
            return <Tooltip title={"Web"}><LaptopIcon sx={{ fontSize: 36 }} /></Tooltip>;
        case LitigeGestionCanalEnum.Rapido :
            return <Tooltip title={"Rapido"}><span><RapidoIcon height={36} width={36} /></span></Tooltip>;
        case LitigeGestionCanalEnum.Autre :
            return <Tooltip title={"Autre"}><DeviceUnknownIcon sx={{ fontSize: 36 }} /></Tooltip>;
        default:
            return null;
    }



}